module.exports = function(btsUI) {
    btsUI.service('ssoServiceHelper', ['session', 'vendorSSOUtility','services','session',
        function(session, vendorSSOUtility,services,session) {
            this.ssoCall = function(ssoParameters,targetLocation,sitePromotionStr,forceNewWindow,isPrescriptionServices){

                var portalSelectedPlan = services.rbsmbl.memberInfo().getPortalSelectedPlan(session.data.memberInfo);
                var clientNumber = session.data.memberInfo.clientList[0].clientNumber;
                var groupNumber = portalSelectedPlan.groupNumber;
                var brand =session.data.memberInfo.brand.toUpperCase();


                var targetLocation = targetLocation?targetLocation:'_blank';
                /*var ssoParameters = {
                    "clientNumber": clientNumber,
                    "groupNumber": groupNumber,
                    "targetType": targetType,
                    "vendorName": vendorName,
                    "category":category,
                    "brand": brand

                };*/
                if(ssoParameters){
                    ssoParameters.clientNumber=clientNumber;
                    ssoParameters.groupNumber =groupNumber;
                    ssoParameters.brand =brand;

                    vendorSSOUtility.performSSO(ssoParameters, targetLocation,sitePromotionStr,forceNewWindow,isPrescriptionServices);
                }



            };

        }
    ]);
// displayOrHideItems ser====================================================================
    btsUI.factory('displayOrHideItemsWrapper', ['$q', 'services',
        function ($q, services) {
            var displayOrHideItemsCall;
            displayOrHideItemsCall = function (paramClientNumber, paramGroupNumber, paramItemsToDisplayOrHide, theBrand) {
                if (!paramClientNumber || !paramGroupNumber || !paramItemsToDisplayOrHide || !theBrand) {
                    throw new Error("Missing required parameter sent to displayOrHideItemsCall.");
                    return null;
                }
                if (!Array.isArray(paramItemsToDisplayOrHide)) {
                    throw new Error("paramItemsToDisplayOrHide has to be an array.");
                    return null;
                }
                var displayOrHideItemsConfig = {
                    brand: theBrand.toUpperCase(),
                    APPID: 'CHMHOM',
                    clientNumber: paramClientNumber,
                    groupNumber: paramGroupNumber,
                    itemsToDisplayOrHide: paramItemsToDisplayOrHide
                };
                return services.rbsmbl.displayOrHideItems().fetch(displayOrHideItemsConfig).then(
                    function (response) {
                        // grab the true or false value here and send that back to the caller
                        if (response && response.data && response.data.payload) {
                            var ssoStuff = response.data.payload;
                            return ssoStuff;
                        } else {
                            return null;
                        }
                    },
                    function (err) {
                        //   console.error('fetch failed in getCurrentMember', err);
                        return $q.reject(err);
                    }
                );
            }
            return {
                displayOrHideItemsCall: displayOrHideItemsCall
            }
        }
    ])

    btsUI.factory('pharmacyServiceWrapper', ['$q', 'services',
        function($q, services) {
            var doPharmacySsoCall;
            doPharmacySsoCall = function(fullMemberInfo, curMember, psp, theTargetType, rxCarveOutVendor) {
                if (!fullMemberInfo || !curMember || !psp || !theTargetType) {
                    return null;
                }
                var pharmacyConfig = {
                    // pds: the next item is not currently used (9/15/15).
                    //      However, it is to be the service's APPID, not the current page's
                    APPID: 'MBRWEB',
                    FromDP: fullMemberInfo.userName,
                    brand: fullMemberInfo.brand,
                    "umi": fullMemberInfo.umi, // user.umi,
                    "firstName": fullMemberInfo.firstName,
                    "lastName": curMember.contact.lastName,
                    "dateOfBirth": curMember.contact.birthDate,
                    "gender": curMember.gender,
                    "relationshipCode": curMember.relationshipCode,
                    "directPaySeniorMember": psp.directPayIndicator,
                    "targetType": theTargetType,
                    "relationship": curMember.relationship,
                    "Clientid": fullMemberInfo.clientList[0].clientNumber,
                    "vendorName": (psp.pharmacyBenefitProviderIndicator) ? psp.pharmacyBenefitProviderIndicator : null
                };

                if (rxCarveOutVendor && rxCarveOutVendor.length > 0) {
                    pharmacyConfig.vendorName = rxCarveOutVendor;
                }

                return services.rbsmbl.prescriptionServices().fetch(pharmacyConfig).then(
                    function(response) {
                        if (response && response.data && response.data.payload) {
                            var ssoStuff = response.data.payload;
                            return ssoStuff;
                        } else {
                            return null;
                        }
                    },
                    function(err) {
                        return $q.reject(err);
                    }
                );
            }
            return {
                doPharmacySsoCall: doPharmacySsoCall
            }
        }
    ])

    btsUI.run(["Service",'$location', function (Service,$location) {
        return new Service({
            name: 'fetchResource',
            group: "mbrweb",
            url: "/content/",
            fetch: function(urlPath) {
                if(urlPath.indexOf("content/dam/")>-1){
                    var urlHost = $location.host();
                    var urlProtocol = $location.protocol();
                    var urlPort = $location.port()?":"+$location.port():"";
                    this.url = urlProtocol+"://"+urlHost+urlPort+urlPath;
                }else{
                    this.url = urlPath;
                }
                return this.get();
            }
        });
    }]);

};
